// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--3PKIO","formItemCol":"formItemCol--Qz74F","labelInfo":"labelInfo--EmZJs","actionButton":"actionButton--1V8Um"};